import React, { useEffect, useState } from 'react';
import { useForm, Controller } from "react-hook-form";
import { FormControl, FormHelperText, TextField, Container, Typography, InputLabel, Paper, Toolbar, Divider, Select, MenuItem, Button, Grid, CircularProgress } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import SaveIcon from '@material-ui/icons/Save';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { PointManagementActions, NotificationActions } from '../../../store';
import { nextDate, calcSubtract } from '../../../utils';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px',
        "& h6": {
            fontSize: '12px'
        }
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const pointManagementSelector = (state) => state.PointManagements;
const IdentitySelector = (state) => state.Identity;

const PointManagementEdit = (props) => {
    const dispatch = useDispatch();
    const pointManagementActions = bindActionCreators(PointManagementActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { editing, nowWainting } = useSelector(pointManagementSelector);
    const { token } = useSelector(IdentitySelector);

    const { control, errors, handleSubmit } = useForm();

    const { classes } = props;

    // 原資負担割合(加盟店)
    const [_merchantRatio, setMerchantRatio] = useState();

    /**
     * 
     * 戻る押下時の処理
     * 
     */
    const onBackClick = () => {
        props.onCancel();
    }

    /**
     * 
     * 登録ボタン押下時の処理
     * 
     */
    const onSubmit = (data, e) => {
        // 日付フォーマット（yyyy-mm-dd）
        editing.period_s = editing.period_s_dt.slice(0, 10);
        editing.period_e = editing.period_e_dt.slice(0, 10);

        // ポイント設定情報を保存
        pointManagementActions.save(token, editing)
            .then(data => {
                // 登録メッセージ表示
                notificationActions.showSuccess('登録しました。');
                // 1つ前の画面に遷移
                props.onCancel();
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    /**
     *
     * 入力内容変更時の処理
     *
     */
    const onChange = (e) => {
        const currentState = editing;
        const { name, value } = e[0].target;

        currentState[name] = value;

        if (name.startsWith('merchant_id')) {
            // 加盟店一覧選択
            const merchant = editing.selectable_merchants.find(merchant => merchant.id === value);
            // 加盟店名を設定
            currentState['merchant_name'] = merchant.merchant_name;
            // 加盟店タイプを設定
            currentState['merchant_type'] = merchant.merchant_type;
        }
        else if (name.startsWith('source_ratio_o')) {
            // 原資負担割合（OKICA）値の変更
            var ratioO = Number(value);
            //var ratioK = calcSubtract(100.0, ratioO);
            //if (ratioK >= 0 && ratioK <= 100) {
            //    // 原資負担割合（加盟店）値を設定
            //    editing.source_ratio_k = ratioK;
            //} else {
            //    // 原資負担割合（OKICA）に範囲外の値を入力されているため原資負担割合（加盟店）には 0をセット
            //    editing.source_ratio_k = 0;
            //}
            //setMerchantRatio(editing.source_ratio_k);
        }
        else if (name.startsWith('apply_kbn_no')) {
            // 変更された適用区分を設定
            editing.apply_kbn = editing.apply_kbn_no == 1 ? true : false;
        }

        return value;
    }

    /**
     *
     * 初期表示処理
     *
     */
    useEffect(() => {
        // 原資負担割合（加盟店）の値を初期設定
        setMerchantRatio(editing.source_ratio_k);
    }, []);

    if (editing == null) {
        return <div></div>;
    }

    // 加盟店一覧の活性・非活性の制御
    var merchantNameDisabled = false;
    // 画面タイトル部
    var titleElement;
    if (props.createFlag) {
        // 新規登録

        // 新規時は加盟店一覧は活性（選択可）
        merchantNameDisabled = false;

        // 画面タイトル部
        titleElement =
            <Grid className={classes.form} container spacing={2}>
                <Grid item xs={12}>
                    <Typography component="h1" variant="inherit">{<FormattedMessage id="PointManagement.AddPointSetting" />}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <InputLabel component="legend"><FormattedMessage id={"PointManagement.AddDesc"} /></InputLabel>
                </Grid>
            </Grid>;
    } else {
        // 編集

        // 編集時は加盟店一覧は非活性（選択不可）
        merchantNameDisabled = true;

        // 画面タイトル部
        titleElement =
            <Grid className={classes.form} container spacing={2}>
                <Grid item xs={12}>
                    <Typography component="h1" variant="inherit">{<FormattedMessage id="PointManagement.EditPointSetting" />}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <InputLabel component="legend"><FormattedMessage id={"PointManagement.EditDesc"} /></InputLabel>
                </Grid>
            </Grid>;
    }

    // 期間(開始)
    var dt = new Date(editing.period_s_dt);
    var startDate = dt.getFullYear() + '-' + ("0" + (dt.getMonth() + 1)).slice(-2) + '-' + ("0" + dt.getDate()).slice(-2);

    // 期間(終了)
    dt = new Date(editing.period_e_dt);
    var endDate = dt.getFullYear() + '-' + ("0" + (dt.getMonth() + 1)).slice(-2) + '-' + ("0" + dt.getDate()).slice(-2);

    // 翌日取得
    // 日付選択可能の下限
    var nextDay = nextDate(new Date(), 1);

    // ポイントチェック値
    var pointMaxLength = 5;
    var pointMin = 0.0;
    var pointMax = 100.0;
    var pointPattern = /^([1-9][0-9]{0,2}|0)(\.[0-9]{1,1})?$/i;

    return (
        <Container className={classes.root} maxWidth={false}>
            <Paper className={classes.paper}>

                {titleElement}

                <form className={classes.form} onSubmit={handleSubmit(onSubmit)} noValidate>
                    <Grid container spacing={2}>

                        <Grid item xs={12}>
                            <FormControl required fullWidth variant="outlined" error={errors.merchant_id && true}>
                                <InputLabel id="point-merchant-id"><FormattedMessage id={"Merchant.Name"} /></InputLabel>
                                <Controller
                                    name="merchant_id"
                                    control={control}
                                    rules={{ required: <FormattedMessage id={"Error.Required"} /> }}
                                    defaultValue={editing.merchant_id ? editing.merchant_id : ''}
                                    onChange={onChange}
                                    disabled={merchantNameDisabled}
                                    as={<Select
                                        labelId="point-merchant-label"
                                        id="point-merchant"
                                        label={<FormattedMessage id={"Merchant.Name"} />}>
                                        {editing.selectable_merchants.map((merchant) => {
                                            return <MenuItem key={merchant.id} value={merchant.id}>{merchant.merchant_name}</MenuItem>
                                        })}
                                    </Select>} />
                                <FormHelperText>{errors.merchant_id ? errors.merchant_id.message : ""}</FormHelperText>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                            <Controller
                                name="point_name"
                                control={control}
                                onChange={onChange}
                                defaultValue={editing.point_name}
                                rules={{
                                    required: <FormattedMessage id={"Error.Required"} />,
                                    maxLength: { value: 50, message: <Typography component="h6">{<FormattedMessage id="Error.PointNameMaxLen" />}</Typography> }
                                }}
                                as={<TextField required fullWidth variant="outlined"
                                    error={errors.point_name && true}
                                    type="text"
                                    helperText={errors.point_name ? errors.point_name.message : ''}
                                    label={<FormattedMessage id={"PointManagement.PointName"} />} />} />
                        </Grid>

                        <Grid item xs={12}>
                            <FormControl required fullWidth variant="outlined" error={errors.point_kbn && true}>
                                <InputLabel id="point-kbn-id"><FormattedMessage id={"PointManagement.PointKbn"} /></InputLabel>
                                <Controller
                                    name="point_kbn"
                                    control={control}
                                    rules={{ required: <FormattedMessage id={"Error.Required"} /> }}
                                    onChange={onChange}
                                    defaultValue={editing.point_kbn ? editing.point_kbn : ''}
                                    as={<Select
                                        labelId="point-kbn-label-id"
                                        id="point-kbn-label-id"
                                        label={<FormattedMessage id={"PointManagement.PointKbn"} />}>
                                        <MenuItem value={1}><FormattedMessage id="PointManagement.PointKbn.Card" /></MenuItem>
                                        <MenuItem value={2}><FormattedMessage id="PointManagement.PointKbn.Qr" /></MenuItem>
                                    </Select>} />
                                <FormHelperText>{errors.point_kbn ? errors.point_kbn.message : ""}</FormHelperText>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12}>
                            <InputLabel component="legend"><FormattedMessage id={"PointManagement.Period"} /></InputLabel>
                        </Grid>
                        <Grid item xs={6}>
                            <Controller
                                name="period_s_dt"
                                control={control}
                                onChange={onChange}
                                defaultValue={startDate}
                                rules={{ required: <FormattedMessage id={"Error.Required"} /> }}
                                as={<TextField required fullWidth variant="outlined"
                                    id="period_s_dt"
                                    label={<FormattedMessage id={"PointManagement.StartDate"} />}
                                    type="date"
                                    error={errors.period_s && true}
                                    helperText={errors.period_s ? errors.period_s.message : ""}
                                    className={classes.textField}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    inputProps={{
                                        min: nextDay,
                                    }}
                                />}
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <Controller
                                name="period_e_dt"
                                control={control}
                                onChange={onChange}
                                defaultValue={endDate}
                                rules={{ required: <FormattedMessage id={"Error.Required"} /> }}
                                as={<TextField required fullWidth variant="outlined"
                                    id="period_e_dt"
                                    label={<FormattedMessage id={"PointManagement.EndDate"} />}
                                    type="date"
                                    error={errors.period_e && true}
                                    helperText={errors.period_e ? errors.period_e.message : ""}
                                    className={classes.textField}
                                    InputLabelProps={{
                                       shrink: true,
                                    }}
                                    inputProps={{
                                        min: nextDay,
                                    }}
                                />}
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <Controller
                                name="point_rate"
                                control={control}
                                onChange={onChange}
                                defaultValue={editing.point_rate}
                                rules={{
                                    required: <FormattedMessage id={"Error.Required"} />,
                                    maxLength: { value: pointMaxLength, message: <FormattedMessage id={"Error.PointMaxLen"} /> },
                                    min: { value: pointMin, message: <FormattedMessage id={"Error.PointMin"} /> },
                                    max: { value: pointMax, message: <FormattedMessage id={"Error.PointMax"} /> },
                                    pattern: { value: pointPattern, message: <FormattedMessage id={"Error.PointPattern"} /> }
                                }}
                                as={<TextField required fullWidth variant="outlined"
                                    error={errors.point_rate && true}
                                    type="number"
                                    helperText={errors.point_rate ? errors.point_rate.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} 10.1%</Typography>}
                                    label={<FormattedMessage id={"PointManagement.PointRate"} />}
                                    inputProps={{
                                        min: pointMin,
                                        max: pointMax,
                                    }}
                                />}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <InputLabel component="legend"></InputLabel>
                        </Grid>

                        <Grid item xs={6}>
                            <Controller
                                name="source_ratio_o"
                                control={control}
                                onChange={onChange}
                                defaultValue={editing.source_ratio_o}
                                rules={{
                                    required: <FormattedMessage id={"Error.Required"} />,
                                    maxLength: { value: pointMaxLength, message: <FormattedMessage id={"Error.PointMaxLen"} /> },
                                    min: { value: pointMin, message: <FormattedMessage id={"Error.PointMin"} /> },
                                    max: { value: pointMax, message: <FormattedMessage id={"Error.PointMax"} /> },
                                    pattern: { value: pointPattern, message: <FormattedMessage id={"Error.PointPattern"} /> }
                                }}
                                as={<TextField required fullWidth variant="outlined"
                                    error={errors.source_ratio_o && true}
                                    type="number"
                                    helperText={errors.source_ratio_o ? errors.source_ratio_o.message : <Typography component="h6">{<FormattedMessage id="Label.Title" />} 0 ～ 100</Typography>}
                                    label={<FormattedMessage id={"PointManagement.OKICASourceRatio"} />}
                                    inputProps={{
                                        min: pointMin,
                                        max: pointMax,
                                    }}
                                />}
                            />
                        </Grid>

                        <Grid item xs={6}>
                            <FormControl required fullWidth variant="outlined" error={errors.apply_kbn && true}>
                                <InputLabel id="point-apply-category"><FormattedMessage id={"PointManagement.ApplicableCategory"} /></InputLabel>
                                <Controller
                                    name="apply_kbn_no"
                                    control={control}
                                    onChange={onChange}
                                    defaultValue={editing.apply_kbn_no}
                                    rules={{ required: <FormattedMessage id={"Error.Required"} /> }}
                                    as={<Select
                                        labelId="point-apply-category"
                                        id="apply-category"
                                        label={<FormattedMessage id={"PointManagement.ApplicableCategory"} />}>
                                        <MenuItem value={1}><FormattedMessage id="PointManagement.Valid" /></MenuItem>
                                        <MenuItem value={0}><FormattedMessage id="PointManagement.Invalid" /></MenuItem>
                                    </Select>} />
                                <FormHelperText>{errors.apply_kbn ? errors.apply_kbn.message : ""}</FormHelperText>
                            </FormControl>
                        </Grid>

                        <Grid container item xs={12} spacing={2} justify="center">
                            <Grid item xs={6}>
                                <Button fullWidth variant="contained" size="medium"
                                    startIcon={<ArrowBackIosIcon />}
                                    onClick={onBackClick}>
                                    <FormattedMessage id="Button.Back" />
                                </Button>
                            </Grid>
                            <Grid item xs={6}>
                                <Button fullWidth variant="contained" size="medium" color="primary"
                                    endIcon={<SaveIcon />}
                                    onClick={handleSubmit(onSubmit)}>
                                    <FormattedMessage id="Button.Register" />
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </form>
            </Paper>
            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(PointManagementEdit);
